/**
 * Vista supported IETF language tags as per cinema.tblLanguage.
 */
export enum LanguageTagEnum {
    Arabic = 'ar',
    Bulgarian = 'bg-BG',
    Bosnian = 'bs-Latn-BA',
    Czech = 'cs-CZ',
    Danish = 'da-DK',
    GermanSwitzerland = 'de-CH',
    GermanGermany = 'de-DE',
    Greek = 'el-GR',
    English = 'en',
    EnglishSingapore = 'en_SG',
    EnglishUnitedStates = 'en-US',
    /**
     * Test language used by Vista developers.
     * Adds a bunch of "X"s to the English text to test that translations are working correctly.
     */
    VistaDeveloperTest = 'eo-VISTA',
    SpanishLatinAmerica = 'es-419',
    Spanish = 'es-ES',
    SpanishMexico = 'es-MX',
    Estonian = 'et-EE',
    Finnish = 'fi-FI',
    FrenchBelgium = 'fr-BE',
    FrenchCanada = 'fr-CA',
    FrenchSwitzerland = 'fr-CH',
    French = 'fr-FR',
    Croatian = 'hr-HR',
    Hungarian = 'hu-HU',
    Armenian = 'hy',
    Icelandic = 'is-IS',
    Italian = 'it-IT',
    Japanese = 'ja-JP',
    Khmer = 'km-KH',
    Lithuanian = 'lt-LT',
    Latvian = 'lv-LV',
    Macedonian = 'mk-MK',
    Mongolian = 'mn-MN',
    Norwegian = 'nb-NO',
    DutchBelgium = 'nl-BE',
    DutchNetherlands = 'nl-NL',
    PortugueseBrazil = 'pt-BR',
    Portuguese = 'pt-PT',
    Romanian = 'ro-RO',
    Russian = 'ru-RU',
    Slovenian = 'sl-SI',
    Albanian = 'sq-AL',
    SerbianLatinMontenegro = 'sr-Latn-ME',
    SerbianLatinSerbia = 'sr-Latn-RS',
    Swedish = 'sv-SE',
    Thai = 'th-TH',
    Turkish = 'tr-TR',
    Ukrainian = 'uk-UA',
    Vietnamese = 'vi-VN',
    ChineseSimplified = 'zh-CN',
    ChineseTraditional = 'zh-TW',
}
